import React, { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Toast } from '@iris/react-components';
import _get from 'lodash/get';

import { useDevice } from '@bonnet/next/device';

import { subscribe } from 'axl-config';

import userDuck from '@/ducks/userDuck';

const {
    toast: {
        title,
        type,
        swipeDirection: { mobile: mobileDirection, desktop: desktopDirection },
        successMessage: { firstPart: firstPartMessage, secondPart: secondPartMessage },
    },
} = subscribe;

const getToastMessage = (isXs) => (
    isXs ? (
        <>
            {firstPartMessage}
            <br />
            {secondPartMessage}
        </>
    ) : `${firstPartMessage} ${secondPartMessage}`
);

export const EmailSubscriptionToast = React.memo(() => {
    const dispatch = useDispatch();
    const device = useDevice();
    const isXs = _get(device, 'is.xs', false);

    const showToast = useSelector(userDuck.selectors.getShowToast);
    const hideToast = useCallback(() => {
        dispatch(userDuck.creators.setShowToast(false));
    }, [dispatch]);
    return (
        <Toast
            swipeDirection={isXs ? mobileDirection : desktopDirection}
            open={showToast}
            message={getToastMessage(isXs)}
            showTitle
            title={title}
            type={type}
            onOpenChange={hideToast}
        />
    );
});

export default EmailSubscriptionToast;
